module.exports = __webpack_public_path__ + "static/media/michael.e1694fee.jpg";